/**
 * Rct Page Loader
 */
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const RctPageLoader = () => (
    <div className="page-loader d-flex justify-content-center mb-30">
        <CircularProgress />
    </div>
);

export default RctPageLoader;
